module.exports = __webpack_public_path__ + "img/screen-with-charts.c2a7786c.svg";